import MixpanelTracker from '../mixpanelTracker';
import {
  G2W_ANALYTICS_DASHBOARD,
  G2W_ANALYTICS_FEATURE,
  G2W_ANALYTICS_REPORT_TYPE,
  TYPE,
  ACTION,
  FORMAT,
  MIN_VALUE,
  MAX_VALUE,
  G2W_ANALYTICS_FILTER_TYPE,
  FEATURE,
  VALUE_ADD,
  GENERATE_REPORT,
  MixpanelReportType,
  CSV,
  PDF,
  EXCEL,
  REPORT_TYPE,
  G2W_ANALYTICS_GENERATE_REPORT_FEATURE,
  G2W_ANALYTICS_CHART_TYPE,
  VALUE,
  G2W_ANALYTICS_EVENT,
  DOWNLOADED,
  VIEWED,
  PROFILE_MENU,
  BACK_TO_OLD_VIEW,
  AnalyticsTypeSwitcher,
  SUB_TYPE,
  G2W_ANALYTICS_TYPE_SWITCHER,
  SEND_EMAIL_REPORT,
  G2W_ANALYTICS_SEND_EMAIL_REPORT,
  G2W_ADMIN_ANALYTICS_DASHBOARD,
  G2W_ADMIN_ANALYTICS_SESSION_DETIALS,
  G2W_ADMIN_ANALYTICS_FEATURE,
  G2W_ADMIN_ANALYTICS_GENERATE_REPORT_FEATURE,
  G2W_ADMIN_ANALYTICS_CHART_TYPE,
  G2W_ADMIN_ANALYTICS_FILTER_TYPE,
  G2W_ADMIN_ANALYTICS_ORGANIZER_FILTER,
  ORGANIZER_COUNT,
  SESSION_KEY,
  G2W_ADMIN_ANALYTICS_DOWNLOAD_REPORT,
  SESSION_KEYS,
  EMAIL,
  DOWNLOAD
} from '../Constants/mixpanelConstants';
import { ReportType } from '../../../Utils/Constants';
import User from '../../../Model/User';

const mixpanelTracker = new MixpanelTracker();

export function trackAnalyticsDashboard(type) {
  const properties = {
    [TYPE]: type
  };
  mixpanelTracker.setEventName(G2W_ANALYTICS_DASHBOARD);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAnalyticsTypeSwitcher(type, subType) {
  const properties = {
    [TYPE]: type,
    [SUB_TYPE]: subType
  };
  mixpanelTracker.setEventName(G2W_ANALYTICS_TYPE_SWITCHER);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();

  if ([AnalyticsTypeSwitcher.SESSION_DETAILS, AnalyticsTypeSwitcher.RECORDING_DETAILS].includes(type)) {
    trackGenericAnalyticsEvent(VIEWED, type, subType);
  }
}

export function trackGenericAnalyticsEvent(action, type = 'None', subType = 'None') {
  const properties = {
    [ACTION]: action
  };

  properties[TYPE] = type;
  properties[SUB_TYPE] = subType;
  mixpanelTracker.setEventName(G2W_ANALYTICS_EVENT);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent(true);
}

export function trackAnalyticsFeature(type, action = '', feature = '') {
  const properties = {
    [TYPE]: type,
    [ACTION]: action
  };
  if (feature) {
    properties[FEATURE] = feature;
  }
  const eventName = isAdmin() ? G2W_ADMIN_ANALYTICS_FEATURE : G2W_ANALYTICS_FEATURE;
  mixpanelTracker.setEventName(eventName);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAnalyticsGenerateReportFeature(reportType, feature = '') {
  const properties = {
    [REPORT_TYPE]: reportType,
    [FEATURE]: feature
  };
  const eventName = isAdmin() ? G2W_ADMIN_ANALYTICS_GENERATE_REPORT_FEATURE : G2W_ANALYTICS_GENERATE_REPORT_FEATURE;
  mixpanelTracker.setEventName(eventName);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAnalyticsReportType(reportType, format) {
  const properties = {
    [FORMAT]: format
  };
  if (reportType) {
    properties[TYPE] = getMixpanelReportType(reportType);
  }
  mixpanelTracker.setEventName(G2W_ANALYTICS_REPORT_TYPE);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();

  trackGenericAnalyticsEvent(DOWNLOADED, getMixpanelReportType(reportType));
}

export function trackAnalyticsChartType(type, format) {
  const properties = {
    [TYPE]: type,
    [FORMAT]: format
  };
  const eventName = isAdmin() ? G2W_ADMIN_ANALYTICS_CHART_TYPE : G2W_ANALYTICS_CHART_TYPE;
  mixpanelTracker.setEventName(eventName);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAnalyticsFilterType(action, type, min = '', max = '', value = '') {
  const properties = {
    [ACTION]: action,
    [TYPE]: type
  };
  if (min) {
    properties[MIN_VALUE] = min;
  }
  if (max) {
    properties[MAX_VALUE] = max;
  }
  if (value) {
    properties[VALUE] = value;
  }
  const eventName = isAdmin() ? G2W_ADMIN_ANALYTICS_FILTER_TYPE : G2W_ANALYTICS_FILTER_TYPE;
  mixpanelTracker.setEventName(eventName);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackReportGeneration(reportType, reportFormat) {
  trackAnalyticsFeature(VALUE_ADD, GENERATE_REPORT, GENERATE_REPORT);
  const format_mix = reportFormat === 'xlsx' ? EXCEL : reportFormat === 'csv' ? CSV : PDF;
  trackAnalyticsReportType(reportType, format_mix);
}

export function trackBackToOldView() {
  const properties = {
    Type: BACK_TO_OLD_VIEW
  };
  mixpanelTracker.setEventName(PROFILE_MENU);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackSendEmail(type) {
  const properties = {
    [ACTION]: SEND_EMAIL_REPORT,
    [TYPE]: type
  };
  mixpanelTracker.setEventName(G2W_ANALYTICS_SEND_EMAIL_REPORT);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAdminAnalyticsDashboard(type) {
  const properties = {
    [TYPE]: type
  };
  mixpanelTracker.setEventName(G2W_ADMIN_ANALYTICS_DASHBOARD);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAdminAnalyticsOrganizerFilter(action, count) {
  const properties = {
    [ACTION]: action,
    [ORGANIZER_COUNT]: count
  };
  mixpanelTracker.setEventName(G2W_ADMIN_ANALYTICS_ORGANIZER_FILTER);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent(true);
}

export function trackAdminAnalyticsSessionDetails(type, sessionKey) {
  const properties = {
    [TYPE]: type,
    [SESSION_KEY]: sessionKey
  };
  mixpanelTracker.setEventName(G2W_ADMIN_ANALYTICS_SESSION_DETIALS);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackAdminReportGeneration(reportType, reportFormat, keys) {
  trackAnalyticsFeature(VALUE_ADD, GENERATE_REPORT, GENERATE_REPORT);
  const format_mix = reportFormat === 'xlsx' ? EXCEL : reportFormat === 'csv' ? CSV : PDF;
  trackAdminAnalyticsDownloadReport(reportType, format_mix, keys);
}

export function trackAdminAnalyticsDownloadReport(reportType, format, keys, sendEmail) {
  const properties = {
    [FORMAT]: format,
    [SESSION_KEYS]: keys,
    [TYPE]: sendEmail ? EMAIL : DOWNLOAD
  };
  if (reportType) {
    properties[ReportType] = getMixpanelReportType(reportType);
  }
  mixpanelTracker.setEventName(G2W_ADMIN_ANALYTICS_DOWNLOAD_REPORT);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

const isAdmin = () => {
  return User.isAdmin;
};

export function getMixpanelReportType(reportType) {
  let mixReportType;
  switch (reportType) {
    case ReportType.SESSIONS_OVERVIEW_REPORT:
      mixReportType = MixpanelReportType.SESSIONS_OVERVIEW_REPORT;
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      mixReportType = MixpanelReportType.WEBINAR_REGISTRATION_REPORT;
      break;
    case ReportType.WEBINAR_ATTENDEE_REPORT:
      mixReportType = MixpanelReportType.WEBINAR_ATTENDEE_REPORT;
      break;
    case ReportType.WEBINAR_QANDA_REPORT:
      mixReportType = MixpanelReportType.WEBINAR_QANDA_REPORT;
      break;
    case ReportType.SESSIONS_ATTENDANCE_REPORT:
      mixReportType = MixpanelReportType.SESSIONS_ATTENDANCE_REPORT;
      break;
    case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
      mixReportType = MixpanelReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT;
      break;
    case ReportType.WEBINAR_PERFORMANCE_REPORT:
      mixReportType = MixpanelReportType.WEBINAR_PERFORMANCE_REPORT;
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      mixReportType = MixpanelReportType.WEBINAR_RECORDING_REPORT;
      break;
    case ReportType.WEBINAR_SURVEY_REPORT:
      mixReportType = MixpanelReportType.WEBINAR_SURVEY_REPORT;
      break;
    case ReportType.RECORDING_VIEWS_REPORT:
      mixReportType = MixpanelReportType.RECORDING_VIEWS_REPORT;
      break;
    default:
      mixReportType = -1;
  }
  return mixReportType;
}



// WEBPACK FOOTER //
// ./src/Telemetry/Mixpanel/Features/analyticsTracker.js